/**
 * The legacy constant tables, typed. Both sources are genuinely global —
 * every feature reads from them — so one module for them is not the
 * aggregation problem legacy.ts was: it reaches two related modules, not
 * twenty unrelated ones.
 *
 * This file goes away when @/constants and @/dao/dbConstants become TypeScript.
 */
// @ts-ignore — untyped legacy JavaScript
import * as constantsModule from '@/constants';
// @ts-ignore — untyped legacy JavaScript
import * as dbConstantsModule from '@/dao/dbConstants';
// @ts-ignore — untyped legacy JavaScript
import { DATATYPE_BOOLEAN_YES_NO as _DATATYPE_BOOLEAN_YES_NO, DATATYPE_DATE as _DATATYPE_DATE, DATATYPE_DATETIME as _DATATYPE_DATETIME, DATATYPE_TIME as _DATATYPE_TIME } from '@/components/dataTable/constants';
// @ts-ignore — untyped legacy JavaScript
import { AI_ASSISTANT_TITLE_FIX_GRAMMAR as _AI_ASSISTANT_TITLE_FIX_GRAMMAR, AI_ASSISTANT_TITLE_IMPROVE_WRITING as _AI_ASSISTANT_TITLE_IMPROVE_WRITING, AI_ASSISTANT_TITLE_MAKE_LONGER as _AI_ASSISTANT_TITLE_MAKE_LONGER, AI_ASSISTANT_TITLE_MAKE_SHORTER as _AI_ASSISTANT_TITLE_MAKE_SHORTER, COMMAND_AI_ASK as _COMMAND_AI_ASK, COMMAND_AI_AUTHOR_BIO_FIX_GRAMMAR as _COMMAND_AI_AUTHOR_BIO_FIX_GRAMMAR, COMMAND_AI_AUTHOR_BIO_IMPROVE_WRITING as _COMMAND_AI_AUTHOR_BIO_IMPROVE_WRITING, COMMAND_AI_AUTHOR_BIO_MAKE_LONGER as _COMMAND_AI_AUTHOR_BIO_MAKE_LONGER, COMMAND_AI_AUTHOR_BIO_MAKE_SHORTER as _COMMAND_AI_AUTHOR_BIO_MAKE_SHORTER } from '@/constants';
// @ts-ignore — untyped legacy JavaScript
import { CONTENT_STATUS as _CONTENT_STATUS } from '@utils/contentStatusUtils';
// @ts-ignore — untyped legacy JavaScript
import { PLATFORMS as _PLATFORMS, PUBLISH_STATUS as _PUBLISH_STATUS } from '@utils/platformConstants';

const constantsTable = constantsModule as unknown as Record<string, unknown>;
const dbTable = dbConstantsModule as unknown as Record<string, unknown>;

export const constants = constantsModule as unknown as Record<string, string>;
export const dbConstants = dbConstantsModule as unknown as Record<string, string>;

const getDbString = (key: string): string => String(dbTable[key] ?? '');
const getDbValue = (key: string): string | number => dbTable[key] as string | number;
const getConstantString = (key: string): string => String(constantsTable[key] ?? '');

export const AI_ASSISTANT_TITLE_FIX_GRAMMAR = _AI_ASSISTANT_TITLE_FIX_GRAMMAR as string;
export const AI_ASSISTANT_TITLE_IMPROVE_WRITING = _AI_ASSISTANT_TITLE_IMPROVE_WRITING as string;
export const AI_ASSISTANT_TITLE_MAKE_LONGER = _AI_ASSISTANT_TITLE_MAKE_LONGER as string;
export const AI_ASSISTANT_TITLE_MAKE_SHORTER = _AI_ASSISTANT_TITLE_MAKE_SHORTER as string;
export const ARTICLE_TYPE_FILE = getDbValue('ARTICLE_TYPE_FILE');
export const ARTICLE_TYPE_GOOGLE = getDbValue('ARTICLE_TYPE_GOOGLE');
export const ARTICLE_TYPE_LINK = getDbValue('ARTICLE_TYPE_LINK');
export const ARTICLE_TYPE_TRIPADVISOR = getDbValue('ARTICLE_TYPE_TRIPADVISOR');
export const ARTICLE_TYPE_YOUTUBE = getDbValue('ARTICLE_TYPE_YOUTUBE');
export const COMMAND_AI_ASK = _COMMAND_AI_ASK as string;
export const COMMAND_AI_AUTHOR_BIO_FIX_GRAMMAR = _COMMAND_AI_AUTHOR_BIO_FIX_GRAMMAR as string;
export const COMMAND_AI_AUTHOR_BIO_IMPROVE_WRITING = _COMMAND_AI_AUTHOR_BIO_IMPROVE_WRITING as string;
export const COMMAND_AI_AUTHOR_BIO_MAKE_LONGER = _COMMAND_AI_AUTHOR_BIO_MAKE_LONGER as string;
export const COMMAND_AI_AUTHOR_BIO_MAKE_SHORTER = _COMMAND_AI_AUTHOR_BIO_MAKE_SHORTER as string;
export const CONTENT_STATUS = _CONTENT_STATUS as Record<string, string>;
export const DATATYPE_BOOLEAN_YES_NO = _DATATYPE_BOOLEAN_YES_NO as string;
export const DATATYPE_DATE = _DATATYPE_DATE as string;
export const DATATYPE_DATETIME = _DATATYPE_DATETIME as string;
export const DATATYPE_TIME = _DATATYPE_TIME as string;
export const SUPPORT_EMAIL = 'support@typehero.ai';
export const ENABLE_PUBLISHING = import.meta.env.REACT_APP_ENABLE_PUBLISHING !== 'false';
export const ENTITY_NAME_ARTICLE = getDbString('ENTITY_NAME_ARTICLE');
export const ENTITY_NAME_BRAND_VOICE = getDbString('ENTITY_NAME_BRAND_VOICE');
export const ENTITY_NAME_CAMPAIGN = getDbString('ENTITY_NAME_CAMPAIGN');
export const ENTITY_NAME_COMPANY = getDbString('ENTITY_NAME_COMPANY');
export const ENTITY_NAME_CONTENT = getDbString('ENTITY_NAME_CONTENT');
export const ENTITY_NAME_CONTENT_GENERATED = getDbString('ENTITY_NAME_CONTENT_GENERATED');
export const ENTITY_NAME_CONTENT_OPTIMIZED = getDbString('ENTITY_NAME_CONTENT_OPTIMIZED');
export const ENTITY_NAME_KNOWLEDGE_BASE = getDbString('ENTITY_NAME_KNOWLEDGE_BASE');
export const ENTITY_NAME_PERMISSION = getDbString('ENTITY_NAME_PERMISSION');
export const ENTITY_NAME_PERSONA = getDbString('ENTITY_NAME_PERSONA');
export const ENTITY_NAME_PRODUCT = getDbString('ENTITY_NAME_PRODUCT');
export const ENTITY_NAME_ROLE = getDbString('ENTITY_NAME_ROLE');
export const ENTITY_NAME_SOURCE_CONTENT = getDbString('ENTITY_NAME_SOURCE_CONTENT');
export const ENTITY_NAME_SOURCE_CONTENT_GENERATED = getDbString('ENTITY_NAME_SOURCE_CONTENT_GENERATED');
export const ENTITY_NAME_SOURCE_CONTENT_OPTIMIZED = getDbString('ENTITY_NAME_SOURCE_CONTENT_OPTIMIZED');
export const ENTITY_NAME_USER = getDbString('ENTITY_NAME_USER');
export const ENTITY_NAME_WRITING_STYLE = getDbString('ENTITY_NAME_WRITING_STYLE');
export const PERMISSION_PREFIX_CREATE = getDbString('PERMISSION_PREFIX_CREATE');
export const PERMISSION_PREFIX_DELETE = getDbString('PERMISSION_PREFIX_DELETE');
export const PERMISSION_PREFIX_UPDATE = getDbString('PERMISSION_PREFIX_UPDATE');
export const PERMISSION_PUBLISH_CREATE = String(dbTable.PERMISSION_PUBLISH_CREATE ?? 'CreatePublish');
export const PERMISSION_PUBLISH_DELETE = String(dbTable.PERMISSION_PUBLISH_DELETE ?? 'DeletePublish');
export const PERMISSION_PUBLISH_UPDATE = String(dbTable.PERMISSION_PUBLISH_UPDATE ?? 'UpdatePublish');
export const PERMISSION_SCHEDULE_CREATE = String(dbTable.PERMISSION_SCHEDULE_CREATE ?? 'CreateSchedule');
export const PERMISSION_UNSCHEDULE_DELETE = String(dbTable.PERMISSION_UNSCHEDULE_DELETE ?? 'DeleteUnschedule');
export const PLATFORMS = _PLATFORMS as Record<string, string>;
export const PUBLISH_STATUS = _PUBLISH_STATUS as Record<string, string>;
export const SCREEN_NAME_CONTENT_OPTIMIZE = String(constantsTable.SCREEN_NAME_CONTENT_OPTIMIZE ?? 'Content > Optimize');
export const SCREEN_NAME_CONTENT_OUTPUT = String(constantsTable.SCREEN_NAME_CONTENT_OUTPUT ?? 'Content > Output');
export const SCREEN_NAME_KNOWLEDGE_BASE_ARTICLE = String(constantsTable.SCREEN_NAME_KNOWLEDGE_BASE_ARTICLE ?? '');
export const SCREEN_NAME_SOURCE_CONTENT_OPTIMIZE = String(constantsTable.SCREEN_NAME_SOURCE_CONTENT_OPTIMIZE ?? 'Model > Optimize');
export const SCREEN_NAME_SOURCE_CONTENT_OUTPUT = String(constantsTable.SCREEN_NAME_SOURCE_CONTENT_OUTPUT ?? 'Model > Output');

export const ENABLE_NEW_UI = Boolean((constantsTable).ENABLE_NEW_UI);
export const ENTITY_NAME_ASSET = getDbString('ENTITY_NAME_ASSET');
export const ENTITY_NAME_FIRM = getDbString('ENTITY_NAME_FIRM');
export const OPERATOR_OR = getDbString('OPERATOR_OR');
export const OPERATOR_AND = getDbString('OPERATOR_AND');
export const OPERATOR_LIKE_CASEINSENSITIVE = getDbString('OPERATOR_LIKE_CASEINSENSITIVE');

export const ROUTE_KNOWLEDGE_BASES = getConstantString('ROUTE_KNOWLEDGE_BASES');
export const ROUTE_KNOWLEDGE_BASE_EDIT = getConstantString('ROUTE_KNOWLEDGE_BASE_EDIT');
export const ROUTE_CAMPAIGN_NEW = getConstantString('ROUTE_CAMPAIGN_NEW');
export const ROUTE_CAMPAIGN_EDIT = getConstantString('ROUTE_CAMPAIGN_EDIT');
export const ROUTE_CONTENT_NEW = getConstantString('ROUTE_CONTENT_NEW');
export const ROUTE_CONTENT_EDIT = getConstantString('ROUTE_CONTENT_EDIT');
export const ROUTE_PRODUCT_NEW = getConstantString('ROUTE_PRODUCT_NEW');
export const ROUTE_PRODUCT_EDIT = getConstantString('ROUTE_PRODUCT_EDIT');
export const ROUTE_SOURCE_CONTENT_NEW = getConstantString('ROUTE_SOURCE_CONTENT_NEW');
export const ROUTE_SOURCE_CONTENT_EDIT = getConstantString('ROUTE_SOURCE_CONTENT_EDIT');
export const ROUTE_ASSET_NEW = getConstantString('ROUTE_ASSET_NEW');
export const ROUTE_ASSET_EDIT = getConstantString('ROUTE_ASSET_EDIT');
